export const Inline = (options) => {
    const { value } = options;
    return () => value;
};
Inline.props = {};
//# sourceMappingURL=inline.js.map